export function joinEvenAndUnevenRows<T>(items: T[]) {
    const result: { left: T; right?: T | undefined }[] = [];
    let currentItem: { left: T; right?: T | undefined } | undefined;
    let counter = 0;
    for (const item of items) {
        if (counter % 2 === 0) {
            currentItem = { left: item };
            result.push(currentItem);
        } else {
            currentItem!.right = item;
        }

        counter++;
    }
    return result;
}
